var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    ref: "memberDetailRef",
    staticClass: "flex flex-col gap-[20px] mb-[10px]"
  }, [_c('main', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.edit,
      expression: "edit"
    }],
    staticClass: "card-info flex xl:gap-[30px] gap-[10px] p-[20px]"
  }, [_c('img', {
    staticClass: "w-[64px] h-[64px] rounded-full",
    attrs: {
      "src": require("../../../../assets/user_init_logo.png")
    }
  }), _c('div', {
    staticClass: "flex flex-col justify-center"
  }, [_c('span', {
    staticClass: "text-[#000] text-[18px] line-[32px]"
  }, [_vm._v(_vm._s(_vm.form.userName))]), _c('p', {
    staticClass: "flex flex-wrap text-[#8490A2] gsap"
  }, [_c('span', {
    staticClass: "pr-[10px]"
  }, [_vm._v(" Iwork ID: " + _vm._s(_vm.row.userId) + " ")]), _c('span', {
    staticClass: "px-[10px] whitespace-nowrap"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.row.status === 10,
      expression: "row.status === 10"
    }],
    staticClass: "bg-[#E3FFF1] text-[#05A660] p-1"
  }, [_vm._v(` ${$t("fj1g2", "在职")} `)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.row.status === 50,
      expression: "row.status === 50"
    }],
    staticClass: "bg-[#FFE6E6] text-[#E63535] p-1"
  }, [_vm._v(` ${$t("lb5z2", "禁用")} `)]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.row.status === 99,
      expression: "row.status === 99"
    }],
    staticClass: "bg-[#FFF8E6] text-[#FF8800] p-1"
  }, [_vm._v(` ${$t("ler52", "离职")} `)])])])])]), _c('Form', {
    ref: "userForm",
    staticClass: "flex flex-col",
    attrs: {
      "model": _vm.form,
      "rules": _vm.myRules,
      "label-position": "top"
    }
  }, [_c('main', {
    staticClass: "p-[20px]"
  }, [_c('div', {
    staticClass: "grid grid-cols-2 gap-x-[20px]"
  }, [_c('FormItem', {
    attrs: {
      "label": $t("hmxge3", "用户名"),
      "prop": "userName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("fqmy2", "姓名")
    },
    on: {
      "on-change": _vm.handleUserNameChange
    },
    model: {
      value: _vm.form.userName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userName", $$v);
      },
      expression: "form.userName"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("i1y32", "昵称"),
      "prop": "userNickname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("i1y32", "昵称")
    },
    model: {
      value: _vm.form.userNickname,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userNickname", $$v);
      },
      expression: "form.userNickname"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("fvdo2", "姓氏"),
      "prop": "userSurname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("fvdo2", "姓氏")
    },
    on: {
      "on-change": _vm.handleNameChange
    },
    model: {
      value: _vm.form.userSurname,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userSurname", $$v);
      },
      expression: "form.userSurname"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("esq22", "名字"),
      "prop": "userGivenName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": $t("esq22", "名字")
    },
    on: {
      "on-change": _vm.handleNameChange
    },
    model: {
      value: _vm.form.userGivenName,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userGivenName", $$v);
      },
      expression: "form.userGivenName"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": $t("f6ql714", "用户代码"),
      "prop": "userCode"
    }
  }, [_vm.edit && _vm.member.userCode ? _c('div', {
    staticClass: "w-full"
  }, [_vm._v(" " + _vm._s(_vm.form.userCode) + " ")]) : _c('Input', {
    attrs: {
      "placeholder": $t("f6ql714", "用户代码"),
      "value": _vm.form.userCode,
      "maxlength": "20"
    },
    on: {
      "input": _vm.handleUserCodeChange
    },
    model: {
      value: _vm.form.userCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userCode", $$v);
      },
      expression: "form.userCode"
    }
  })], 1), _vm.form.interfaceOnly !== 'T' ? _c('FormItem', {
    staticClass: "cellNumber",
    attrs: {
      "label": $t("ewbd43", "手机号")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [this.isDetail || this.edit ? [_vm.form.userMobile ? _c('ProEncInput', {
    attrs: {
      "disabled": "",
      "params": {
        unitId: this.row.unitId,
        userId: this.member.userId
      },
      "mode": "UNIT_USER_MOBILE"
    },
    model: {
      value: _vm.form.userMobile,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userMobile", $$v);
      },
      expression: "form.userMobile"
    }
  }) : _c('span', [_vm._v($t("dd1tam4", "暂无设置"))])] : _c('CountryCode', {
    ref: "countryCode",
    staticClass: "w-full",
    attrs: {
      "formKey": "userMobile",
      "isRequired": false,
      "exist": _vm.edit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 2)]) : _vm._e(), _vm.form.interfaceOnly !== 'T' ? _c('FormItem', {
    attrs: {
      "label": $t("padf2", "邮箱"),
      "prop": "userEmail"
    }
  }, [_c('ProEncInput', {
    attrs: {
      "params": {
        unitId: _vm.row.unitId,
        userId: _vm.member.userId
      },
      "mode": "UNIT_USER_EMAIL",
      "rangeId": "userJoinInputEmail",
      "placeholder": $t("padf2", "邮箱")
    },
    on: {
      "onChange": _vm.handleEmailChange
    },
    model: {
      value: _vm.form.userEmail,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userEmail", $$v);
      },
      expression: "form.userEmail"
    }
  })], 1) : _vm._e(), _c('FormItem', {
    attrs: {
      "label": $t("gfjm2", "工号"),
      "prop": "userNumber"
    }
  }, [_c('Input', {
    model: {
      value: _vm.form.userNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "userNumber", $$v);
      },
      expression: "form.userNumber"
    }
  })], 1), _c('FormItem', {
    staticClass: "col-span-2",
    attrs: {
      "label": $t("pgxs2", "部门")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('ProChiose', {
    attrs: {
      "icon": "icon-user_tianjiarenqun_people-plus"
    },
    on: {
      "onChange": list => this.handleProChioseChange(list, 'departmentIds', 'orgId')
    },
    model: {
      value: _vm.departmemt.checkedList,
      callback: function ($$v) {
        _vm.$set(_vm.departmemt, "checkedList", $$v);
      },
      expression: "departmemt.checkedList"
    }
  })], 1)]), _c('FormItem', {
    staticClass: "col-span-2",
    attrs: {
      "label": $t("g6mu2", "岗位")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('ProChiose', {
    attrs: {
      "tabs": ['position'],
      "title": $t("iky1sm4", "选择岗位"),
      "icon": "icon-user_tianjiauser_add-user"
    },
    on: {
      "onChange": list => this.handleProChioseChange(list, 'positionIds', 'tagId')
    },
    model: {
      value: _vm.position.checkedList,
      callback: function ($$v) {
        _vm.$set(_vm.position, "checkedList", $$v);
      },
      expression: "position.checkedList"
    }
  })], 1)]), _c('FormItem', {
    staticClass: "col-span-2",
    attrs: {
      "label": $t("gqac2", "应用")
    }
  }, [_c('div', {
    staticClass: "inline-block w-full"
  }, [_c('ProChiose', {
    attrs: {
      "tabs": ['apps'],
      "title": $t("cf7dsp4", "应用管理"),
      "icon": "icon-hardware_jisuanjitianjia_add-computer"
    },
    on: {
      "onChange": list => this.handleProChioseChange(list, 'appIds', 'id')
    },
    model: {
      value: _vm.apps.checkedList,
      callback: function ($$v) {
        _vm.$set(_vm.apps, "checkedList", $$v);
      },
      expression: "apps.checkedList"
    }
  })], 1)])], 1)])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };